'use client';

import React from 'react';
import { Inbox, Clock, Mic, CheckCircle, TrendingUp, Users, Eye } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';



const STATS = [
  {
    id: 'stat-total',
    label: 'Total Recibidos',
    value: '4,218',
    sub: '+47 hoy',
    icon: Inbox,
    trend: 'up',
    color: 'text-secondary',
    bg: 'bg-secondary/10',
    border: 'border-secondary/20',
  },
  {
    id: 'stat-pending',
    label: 'Pendientes de Revisar',
    value: '89',
    sub: '12 nuevos esta hora',
    icon: Clock,
    trend: 'warning',
    color: 'text-amber-600',
    bg: 'bg-amber-50',
    border: 'border-amber-200',
  },
  {
    id: 'stat-queue',
    label: 'En Cola para Live',
    value: '14',
    sub: 'Próximo: vecinos 🏠',
    icon: Mic,
    trend: 'up',
    color: 'text-primary',
    bg: 'bg-primary/10',
    border: 'border-primary/20',
  },
  {
    id: 'stat-counted',
    label: 'Contados en Vivo',
    value: '247',
    sub: '+8 en este live',
    icon: CheckCircle,
    trend: 'up',
    color: 'text-green-600',
    bg: 'bg-green-50',
    border: 'border-green-200',
  },
  {
    id: 'stat-votes',
    label: 'Votos Totales',
    value: '18,742',
    sub: '+312 hoy',
    icon: TrendingUp,
    trend: 'up',
    color: 'text-accent',
    bg: 'bg-accent/10',
    border: 'border-accent/20',
  },
  {
    id: 'stat-viewers',
    label: 'Espectadores Ahora',
    value: '1,247',
    sub: 'Pico: 2,103 ayer',
    icon: Eye,
    trend: 'neutral',
    color: 'text-secondary',
    bg: 'bg-secondary/10',
    border: 'border-secondary/20',
  },
  {
    id: 'stat-followers',
    label: 'Seguidores',
    value: '892',
    sub: '+23 esta semana',
    icon: Users,
    trend: 'up',
    color: 'text-primary',
    bg: 'bg-primary/10',
    border: 'border-primary/20',
  },
];

export default function AdminStats() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-4 mb-8">
      {/* Hero stat — spans 2 cols */}
      <div className={`col-span-2 bg-card border-2 ${STATS?.[0]?.border} rounded-2xl p-6 shadow-sm flex items-center gap-5`}>
        <div className={`w-14 h-14 rounded-2xl ${STATS?.[0]?.bg} flex items-center justify-center shrink-0`}>
          <Inbox size={26} className={STATS?.[0]?.color} />
        </div>
        <div>
          <div className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-1">{STATS?.[0]?.label}</div>
          <div className={`text-4xl font-extrabold font-tabular ${STATS?.[0]?.color}`}>{STATS?.[0]?.value}</div>
          <div className="text-xs text-muted-foreground mt-1">{STATS?.[0]?.sub}</div>
        </div>
      </div>
      {/* Warning stat */}
      <div className={`bg-card border-2 ${STATS?.[1]?.border} rounded-2xl p-5 shadow-sm`}>
        <div className="flex items-center justify-between mb-3">
          <div className={`w-9 h-9 rounded-xl ${STATS?.[1]?.bg} flex items-center justify-center`}>
            <Clock size={18} className={STATS?.[1]?.color} />
          </div>
          <span className="text-xs bg-amber-100 text-amber-700 px-2 py-1 rounded-full font-semibold">⚠️ Revisar</span>
        </div>
        <div className={`text-3xl font-extrabold font-tabular ${STATS?.[1]?.color}`}>{STATS?.[1]?.value}</div>
        <div className="text-xs font-semibold text-muted-foreground mt-0.5">{STATS?.[1]?.label}</div>
        <div className="text-xs text-muted-foreground mt-1">{STATS?.[1]?.sub}</div>
      </div>
      {/* Remaining stats */}
      {STATS?.slice(2)?.map((stat) => {
        const Icon = stat?.icon;
        return (
          <div key={stat?.id} className={`bg-card border ${stat?.border} rounded-2xl p-5 shadow-sm`}>
            <div className={`w-9 h-9 rounded-xl ${stat?.bg} flex items-center justify-center mb-3`}>
              <Icon size={18} className={stat?.color} />
            </div>
            <div className={`text-2xl font-extrabold font-tabular ${stat?.color}`}>{stat?.value}</div>
            <div className="text-xs font-semibold text-muted-foreground mt-0.5">{stat?.label}</div>
            <div className="text-xs text-muted-foreground mt-1">{stat?.sub}</div>
          </div>
        );
      })}
    </div>
  );
}